import { render, staticRenderFns } from "./SmartCollege.vue?vue&type=template&id=5165fb99&scoped=true&"
import script from "./SmartCollege.vue?vue&type=script&lang=ts&"
export * from "./SmartCollege.vue?vue&type=script&lang=ts&"
import style0 from "./SmartCollege.vue?vue&type=style&index=0&id=5165fb99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165fb99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
